import { useEffect, useState } from 'react';
import { subscribeLicitacionFee } from '../services/licitacionesService';

const SIN_FEE = { feeBps: null, feesPorColocador: null, isLoading: false, error: null };
const CARGANDO = { feeBps: null, feesPorColocador: null, isLoading: true, error: null };
const SIN_LECTURA = { id: null, feeBps: null, feesPorColocador: null, error: null };

/**
 * Fee de colocación de una licitación, en vivo. Solo para personal interno: a un
 * productor las reglas le niegan la lectura, así que en ese modo se pasa
 * `enabled: false` y no se suscribe.
 *
 * - `feeBps`: fee único de las licitaciones anteriores a los colocadores.
 * - `feesPorColocador`: { [colocadorId]: bps } de las licitaciones con colocadores.
 *
 * `isLoading` se deriva en el mismo render en que cambia la licitación (no después del
 * efecto): quien inicializa un formulario con el fee nunca ve un "sin fee" transitorio.
 *
 * @returns {{ feeBps: number|null, feesPorColocador: object|null, isLoading: boolean, error: Error|null }}
 */
export const useLicitacionFee = (licitacionId, { enabled = true } = {}) => {
  const [lectura, setLectura] = useState(SIN_LECTURA);
  const id = enabled && licitacionId ? licitacionId : null;

  useEffect(() => {
    if (!id) {
      setLectura(SIN_LECTURA);
      return undefined;
    }
    return subscribeLicitacionFee(
      id,
      ({ feeBps, feesPorColocador }) => setLectura({ id, feeBps, feesPorColocador, error: null }),
      (error) => setLectura({ id, feeBps: null, feesPorColocador: null, error }),
    );
  }, [id]);

  if (!id) return SIN_FEE;
  if (lectura.id !== id) return CARGANDO;
  return { feeBps: lectura.feeBps, feesPorColocador: lectura.feesPorColocador, isLoading: false, error: lectura.error };
};
